import { Address } from './address';
import { SessionStatus } from './session-status';
import { TimeSlotType } from './time-slot-type';
import { ITimeSlot } from '../interfaces/i-time-slot';
import { User } from '../micro-services/user/models/user';

export class Session implements ITimeSlot{
    type : TimeSlotType.Session
    id: number | null;
    title: string | null;
    startDate: string;
    endDate: string;
    address: Address | null;
    clients: User[] | null;
    coach: User | null;
    note: string | null;
    color: string;
    status: SessionStatus;
    isChecked: boolean;
    animation: string = 'inactive';
}
